const products = [
  {
    id: "vpn",
    name: "JEKO VPN",
    tagline: "Privacy Without Compromise",
    description:
      "JEKO VPN delivers enterprise-grade encryption directly to your iPhone. With one-tap connection and military-grade 256-bit protocols, your data remains private across every network — from home Wi-Fi to public hotspots.",
    highlights: [
      "256-bit AES encryption",
      "Zero-log policy",
      "Global server coverage",
      "Automatic kill switch",
      "Split tunneling support",
    ],
    icon: "ri-shield-keyhole-line",
    accentClass: "from-emerald-900/40 to-emerald-800/10",
    borderClass: "border-emerald-500/20",
    img: "https://public.readdy.ai/ai/img_res/c5f833674f448868cdcc3f3f2affb8c4.jpg",
  },
  {
    id: "cleaner",
    name: "JEKO Cleaner",
    tagline: "Maximum Performance, Minimal Clutter",
    description:
      "JEKO Cleaner intelligently scans your device to eliminate redundant files, duplicate photos, and cached data that silently consume storage. The result: a faster, more responsive iPhone with reclaimed space.",
    highlights: [
      "Smart duplicate detection",
      "Cache & junk removal",
      "Photo library optimizer",
      "Storage analytics dashboard",
      "Safe, reversible cleaning",
    ],
    icon: "ri-speed-up-line",
    accentClass: "from-teal-900/40 to-teal-800/10",
    borderClass: "border-teal-500/20",
    img: "https://readdy.ai/api/search-image?query=sleek%20iPhone%20smartphone%20product%20photography%20device%20cleaner%20optimization%20app%20storage%20management%20interface%20dark%20minimal%20background%20teal%20green%20accent%20glow%20iOS%20application%20modern%20clean%20premium%20performance%20speed%20mobile%20app%20interface%20professional&width=360&height=660&seq=jeko-cleaner-product-001&orientation=portrait",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="bg-[#0d0d0d] py-32 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-8 h-0.5 bg-emerald-400" />
            <span className="text-emerald-400 text-xs font-semibold tracking-widest uppercase">
              Our Products
            </span>
            <span className="w-8 h-0.5 bg-emerald-400" />
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Crafted for iOS. Built to Last.
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed">
            Two powerful applications designed from the ground up to enhance
            your iPhone experience in the ways that matter most.
          </p>
        </div>

        {/* Product cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className={`relative rounded-3xl border ${product.borderClass} bg-gradient-to-br ${product.accentClass} bg-[#141414] overflow-hidden group`}
            >
              <div className="p-10">
                <div className="flex items-start gap-6">
                  {/* Icon */}
                  <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-emerald-400/10 border border-emerald-400/20 flex-shrink-0">
                    <i className={`${product.icon} text-emerald-400 text-xl`} />
                  </div>

                  {/* Text */}
                  <div className="flex-1">
                    <p className="text-xs text-emerald-400 font-semibold tracking-widest uppercase mb-1">
                      {product.tagline}
                    </p>
                    <h3
                      className="text-2xl font-bold text-white mb-4"
                      style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                    >
                      {product.name}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed mb-6">
                      {product.description}
                    </p>

                    {/* Highlights */}
                    <ul className="space-y-2">
                      {product.highlights.map((h) => (
                        <li key={h} className="flex items-center gap-3 text-sm text-gray-300">
                          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0" />
                          {h}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Product screenshot */}
              <div className="mt-4 px-10 pb-0 flex justify-center">
                <div className="w-44 h-72 rounded-t-2xl overflow-hidden shadow-2xl">
                  <img
                    src={product.img}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
